"use strict"
window.an = window.an || {};
window.jQuery = window.$ = require('jquery');

require('owl.carousel');
require('is-in-viewport');
require('select2');
require('@fancyapps/fancybox');


jQuery(document).ready(function () {
    require('./components/tax-calculator');
    require('./components/treedropdown');
    require('./components/properties-load');
    require('./components/animations');
    require('./components/carousel');
    require('./components/form');
    require('./components/menu');
});
